import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

import arrow from "../assets/kangaroo/whitearrow.png";
import australia from "../assets/kangaroo/Home_Country_Australia.jpg";
import newZealand from "../assets/kangaroo/Home_Country_New Zealand.jpg";
import usa from "../assets/kangaroo/Home_Country_USA.jpg";
import uk from "../assets/kangaroo/Home_Country_UK.jpg";
import canada from "../assets/kangaroo/Home_Country_Canada.jpg";
import { useNavigate } from "react-router-dom";
import Form from "../component/Form/Form";

import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../services/imageBaseApi";
import IntelligenceDashboardService from "../services/IntelligenceDashboard";
import WidgetsService from "../services/WidgetsService";
import { Link2, Loader } from "lucide-react";

const Explore = () => {
  const router = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [hoveredId, setHoveredId] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen);
  const fetchCountryData = async () => {
    const response = await IntelligenceDashboardService.getList();
    return response;
  };

  const {
    isPending,
    error,
    data: countrydata,
  } = useQuery({
    queryKey: ["countryDatass"],
    queryFn: fetchCountryData,
  });

  const fetchWidgets = async (isOnshore = true) => {
    const response = await WidgetsService.getHomeWidgets(1, isOnshore);
    return response;
  };

  const {
    data: WidgetData,
    isPending: WidgetPending,
    error: WidgetError,
  } = useQuery({
    queryKey: ["WidgetData", true],
    queryFn: () => fetchWidgets(true),
  });

  console.log("🚀 ~ Explore ~ WidgetData:", WidgetData);

  const renderContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H1") {
        return (
          <Row key={index}>
            <Col>
              <h1 className="font-level-4 lh-1" style={{ marginTop: "2rem" }}>
                {child.textContent}
              </h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H2") {
        return (
          <Row key={index}>
            <Col>
              <h1 className="font-level-8" style={{ marginTop: "2rem" }}>
                {child.textContent}
              </h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H3") {
        return (
          <Row key={index}>
            <Col>
              <h1 className="font-level-7" style={{ marginTop: "2rem" }}>
                {child.textContent}
              </h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "P" && child.textContent.trim()) {
        return (
          <Row key={index}>
            <Col>
              <p
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      if (child.tagName === "UL") {
        return (
          <Row key={index}>
            <Col>
              <ul
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      if (child.tagName === "OL") {
        return (
          <Row key={index}>
            <Col>
              <ol
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      return null;
    });
  };
  if (isPending) {
    return <Loader style={{ height: "100vh", color: "#fff" }} />
  }
  if (error) return <div>Error: {error.message}</div>;

  const overlays = {
    AUSTRALIA: "rgba(240, 90, 70, 0.55)",
    "NEW ZEALAND": "rgba(0, 200, 200, 0.5)",
    USA: "rgba(200, 180, 60, 0.54)",
    UK: "#52127f79",
    CANADA: "#687c867c",
    JAPAN: "rgba(100, 150, 200, 0.5)", // add as needed
  };

  const CountryCard = ({ image, overlay, title, caption, slug }) => (
    <Link to={`${slug}`} style={{ textDecoration: "none" }}>
      <div
        className="position-relative rounded-5 mx-auto"
        style={{
          height: "clamp(200px, 40vw, 360px)",
          width: "clamp(200px, 40vw)",
          overflow: "hidden",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        {/* Image */}
        <img
          src={image}
          loading="lazy"
          alt={title}
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        />

        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: overlay,
          }}
        />

        {/* Text container */}
        <div
          className="position-absolute w-100 px-3 d-flex align-items-end"
          style={{ bottom: "15%", left: 0, zIndex: 2 }}
        >
          <div
            className="font-level-5 mb-0 ms-2"
            style={{
              color: "white",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              maxWidth: "100%",
              lineHeight: "1.2",
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
      </div>
    </Link>
  );

  if (error) return <div>Error: {error.message}</div>;
  if (!countrydata || !Array.isArray(countrydata)) {
    return <div>No country data available</div>;
  }

  return (
    <div className="main-container">
      <Container
        fluid
        className="justify-content-start"
        style={{ marginBottom: "clamp(1rem, 16vw, 5rem)" }}
      >
        <Row
          className="justify-content-between"
          style={{ marginTop: "1rem", cursor: "pointer" }}
        >
          <h1
            className="lh-1 font-level-4 fw-normal text-start p-0 "
            style={{ marginBottom: "clamp(1rem,5vw,4.2rem)" }}
          >
            KANGAROO EDUCATION FOUNDATION SERVICES
            {/* <br className="d-none d-md-block" /> */}
          </h1>

          <div className="row g-3 m-0 p-0">
            {countrydata
              ?.filter((country) => country.isOnshoreIntelMenu === true)
              ?.map((country) => (
                <Col
                  key={country.id}
                  xs="12"
                  sm="6"
                  lg="4"
                  xl="4"
                  className="cursor-pointer"
                >
                  <CountryCard
                    image={`${imageBaseApi}${country.logoImage?.url}`}
                    overlay={
                      overlays[country.name.toUpperCase()] || "rgba(0,0,0,0.5)"
                    }
                    title={country.name.toUpperCase()}
                    slug={country?.url}
                  />
                </Col>
              ))}

            {/* Special "Begin Your Journey" card */}
            {/* <Col xs="12" sm="6" lg="4" xl="4" className="cursor-pointer">
        <div
          className="d-flex flex-column justify-content-center align-items-start rounded-5 px-5 pt-5"
          style={{
            backgroundColor: "#ff4d1d",
            height: "clamp(200px, 40vw, 360px)",
            width: "100%", // fill column width
            cursor: "pointer",
            transition: "transform 0.3s ease, box-shadow 0.3s ease"
          }}
          onClick={toggleModal}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(255, 77, 29, 0.5)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <img 
            src={arrow} 
            alt="Arrow" 
            loading="lazy"
            style={{ height: "clamp(40px, 8vw, 60px)", marginBottom: "1rem" }}
          />
          <h1 className="font-level-5 text-start" style={{ color: "white" }}>
            BEGIN <br /> YOUR <br /> JOURNEY
          </h1>
        </div>
      </Col> */}
          </div>

          <div>
            <Form
              modal={modalOpen}
              toggle={toggleModal}
              heading="Start Your Global Journey Today"
              description="Tell us a bit about yourself and we'll guide you toward the right country, university, and course."
              closingMessage="YOU'RE ALL SET!"
              closingDesc="Our team will help you explore the best global options for your study journey"
              Explore={true}
              formOrigin={4}
            />
          </div>
        </Row>

        <hr className="line mb-1" />
      </Container>
      {/* {WidgetData?.map((widget) => renderContent(widget?.widget?.description))} */}
      {WidgetData?.map((widget) => {
        const children = widget?.widget?.children || [];

        return (
          <Row key={widget.id} style={{ flexWrap: "nowrap" }}>
            <Col>
              {children
                ?.sort((a, b) => a.orderIndex - b.orderIndex)
                ?.map((item, i) => {
                  const hasUrl = (item?.url && item?.url !== "") || (item?.media?.url !== "" && item?.media?.url);

                  const heading = (
                    <h1
                      className="list-text lh-1"
                      style={{
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        whiteSpace: "normal",
                      }}
                    >
                      {item?.headingName}
                      {hoveredId === item.id && hasUrl && <Link2 size={16} className="ms-1" />}
                    </h1>
                  );

                  return (
                    <React.Fragment key={item.id}>
                      <hr
                        className="line"
                        style={{
                          marginTop: "3.4rem",
                          marginBottom: "2.5rem",
                        }}
                      />

                      {hasUrl ? (
                        <a
                          href={
                            item?.isPdf
                              ? imageBaseApi + item?.media?.url
                              : item?.url.startsWith("http")
                                ? item?.url
                                : `https://${item?.url}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cursor-pointer text-decoration-none"
                          onMouseEnter={() => setHoveredId(item.id)}
                          onMouseLeave={() => setHoveredId(null)}
                        >
                          {heading}
                        </a>
                      ) : (
                        heading
                      )}

                      <p
                        className="country-paragraph-text"
                        style={
                          i === children.length - 1
                            ? { marginBottom: "12.4rem" }
                            : { marginBottom: "0rem" }
                        }
                        dangerouslySetInnerHTML={{ __html: item?.description }}
                        ref={(el) => {
                          if (!el) return;

                          el.querySelectorAll("a").forEach((a) => {
                            a.style.textDecoration = "none";
                            a.style.color = "#7e1790";
                            a.target = "_blank";
                            a.rel = "noopener noreferrer";
                            a.style.position = "relative";

                            let icon;

                            const mouseEnter = () => {
                              icon = document.createElement("span");
                              icon.innerHTML = " 🔗";
                              icon.style.marginLeft = "6px";
                              icon.className = "hover-link-icon";

                              a.appendChild(icon);
                            };

                            const mouseLeave = () => {
                              if (icon && a.contains(icon)) {
                                a.removeChild(icon);
                              }
                            };

                            a.addEventListener("mouseenter", mouseEnter);
                            a.addEventListener("mouseleave", mouseLeave);
                          });

                          el.querySelectorAll("p").forEach((p) => {
                            p.style.margin = "0.4rem";
                          });
                        }}
                      />
                    </React.Fragment>
                  );
                })}
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default Explore;
